import BybPerformanceChip from "@Components/common/byb-ds/byb-performance-chip";
import BybVrCard from "@Components/common/byb-ds/cards/byb-vr-card";
import formatMetricScoreType from "@Containers/app/stat-cards/tooltips/format-metric-type";
import { useSessionResultsScenarioData, useSessionResultsTabContext } from "@Context/game/activity/session-results-context";
import MetricFilterTypes from "@Enums/MetricFilterTypes";
import { IPerformanceStats } from "@hooks/game/activity/session/use-session-results";
import useI18n from "@i18n";
import { Box, Skeleton, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FillingBrainIcon from "@Resources/app/icons-v2/system-icons/filling-brain-icon";
import MetricsSection from "../metrics/metrics-section";

const OverviewSection = () => {
  const theme = useTheme();
  const { i18n } = useI18n();
  const { currentTab } = useSessionResultsTabContext();
  const { scenarioData } = useSessionResultsScenarioData();

  const bybIqMetric = scenarioData?.performanceStats?.find((metric: IPerformanceStats) => metric.type === MetricFilterTypes.BYB_IQ);
  const bybIq = bybIqMetric?.score || 0;

  return (
    <Stack spacing={2} padding={theme.spacing(0, 4)}>
      <Stack direction="row" spacing={1.5}>
        <Typography variant="text1xl700" color="dsBase.v200">
          {currentTab === 0 ? i18n("session-results.results.overall-result") : i18n("session-results.results.scenario-result", { index: currentTab })}
        </Typography>
      </Stack>

      <Stack direction="row" gap={3}>
        <Box width="25%">
          <BybVrCard>
            <Stack spacing={2.5} paddingY={3.5} alignItems="center" justifyContent="center" height="100%">
              {scenarioData ? (
                <FillingBrainIcon size={175} fillPercentage={bybIq / 10.0} target={bybIqMetric?.target || 0} />
              ) : (
                <FillingBrainIcon size={175} loading={true} />
              )}
              <Stack spacing={3.5} alignItems="center" justifyContent="center">
                {scenarioData ? (
                  <>
                    <Stack alignItems="center" gap={1.25}>
                      <Typography variant="text3xl700" color="dsBase.v200">
                        {i18n("progress.byb_iq.score", { byb_iq: formatMetricScoreType(MetricFilterTypes.BYB_IQ, bybIq) })}
                      </Typography>
                      <Typography variant="textLg400" color="dsNeutral.v300">
                        {i18n("session-result.session-score")}
                      </Typography>
                    </Stack>
                    <BybPerformanceChip score={bybIq} />
                  </>
                ) : (
                  <Stack gap={3} alignItems="center">
                    <Stack alignItems="center" gap={0}>
                      <Skeleton variant="text" width={150} height={42.5} animation="wave" />
                      <Skeleton variant="text" width={100} height={30} animation="wave" />
                    </Stack>
                    <Skeleton variant="text" width={75} height={35} animation="wave" />
                  </Stack>
                )}
              </Stack>
            </Stack>
          </BybVrCard>
        </Box>

        <Box width="75%">
          <MetricsSection />
        </Box>
      </Stack>
    </Stack>
  );
};

export default OverviewSection;
